module.exports = __webpack_public_path__ + "static/media/Voiceflow.4bd8449e.png";